<!-- sanduhr_hochformat -->
{#if pattern && pattern.includes('sanduhr_hochformat') || !pattern}
<svg
  xmlns="http://www.w3.org/2000/svg"
  width="0"
  height="0"
  class="SvgClip"
  viewBox="0 0 284.462 387.572"
>
  <defs>
    <clipPath
      id="sanduhr_hochformat{id ? '_' +id: ''}"
      transform="{transformClip('sanduhr_hochformat', cardWidth, cardHeight, smallSize)}"
    >
      <path
        d="M465.606,794.083c-13.406-10.82-15.07-26.6,2.222-38.87a38.548,38.548,0,0,0,16.253-31.1c0-.124,0-.246,0-.371a38.178,38.178,0,0,0-38.178-38.178c-.252,0-.5,0-.753.01h0l-.106,0-.161,0c-.078,0-.165.006-.255.01-.152,0-.3.014-.455.021H345.042c-1.381-.084-2.186-.045-2.186-.045-.252,0-.5,0-.753.01h0l-.106,0-.161,0c-.078,0-.166.006-.255.01-.152,0-.3.014-.455.021H241.991c-1.381-.084-2.185-.045-2.185-.045a38.178,38.178,0,0,0-38.178,38.178c0,.432.01.862.024,1.291a.215.215,0,0,0-.005.023c0,.4.032,1.048.116,1.882a37.934,37.934,0,0,0,4.178,14.443,36.921,36.921,0,0,0,11.945,14.173c14.333,10.064,17.752,25.324,3.484,37.8a38.167,38.167,0,0,0-19.735,32.91c0,.2-.006.366-.006.511v.029c0,.195,0,.341.005.432a38.016,38.016,0,0,0,8.807,23.952,35.727,35.727,0,0,0,7.445,7.027c14.883,10.45,18,26.5,1.766,39.225A38.158,38.158,0,0,0,201.7,927.56c-.072,1.032-.075,1.777-.07,2.159,0,.05,0,.1,0,.149a38.09,38.09,0,0,0,13.385,29.03,35.5,35.5,0,0,0,2.873,2.253c15.321,10.758,18.172,27.452.281,40.339a38.151,38.151,0,0,0-16.373,27.908,28.4,28.4,0,0,0-.162,3.318c0,.076,0,.152,0,.228a38.177,38.177,0,0,0,38.178,38.178c.121,0,.241,0,.362-.006v.006H444.877v-.017c.343.009.686.017,1.031.017a38.179,38.179,0,0,0,20.812-70.187c-14.415-10.83-16.65-27.137,1.109-39.735a38.445,38.445,0,0,0,15.988-26.788,30.217,30.217,0,0,0,.266-4.266c0-.093,0-.185,0-.278a38.149,38.149,0,0,0-17.635-32.185c-14.176-10.83-16.272-27.014,1.377-39.534a37.846,37.846,0,0,0,12.487-14.793l.077-.165c.051-.11.1-.219.154-.329a37.911,37.911,0,0,0,3.245-11.311,30.429,30.429,0,0,0,.291-4.465c0-.1,0-.2,0-.294a38.155,38.155,0,0,0-18.48-32.709"
        transform="translate(-200.627 -684.55)"
      />
    </clipPath>
  </defs>
</svg>
{/if}

<!-- sanduhr_querformat -->
{#if pattern && pattern.includes('sanduhr_querformat') || !pattern}
<svg
  xmlns="http://www.w3.org/2000/svg"
  width="0"
  height="0"
  viewBox="0 0 385.092 284.46"
  preserveAspectRatio="xMidYMid meet"
  class="SvgClip"
>
  <defs>
    <clipPath
      id="sanduhr_querformat{id ? '_' +id: ''}"
      transform="{transformClip('sanduhr_querformat', cardWidth, cardHeight, smallSize)}"
    >
      <path
        d="M369.551,91.136c-9.821-7.927-11.039-19.488,1.627-28.475a28.237,28.237,0,0,0,11.907-22.785c0-.091,0-.18,0-.271A27.968,27.968,0,0,0,355.12,11.638c-.184,0-.368,0-.553.006h-.078l-.118,0-.187.007c-.112,0-.222.011-.334.016H29.569a15.992,15.992,0,0,0-1.6-.033A27.968,27.968,0,0,0,0,39.606c0,.316.007.631.018.946,0,.005,0,.011,0,.017,0,.294.024.767.085,1.379A27.789,27.789,0,0,0,3.16,52.527,27.04,27.04,0,0,0,11.91,62.91c10.5,7.373,13,18.552,2.552,27.693A27.961,27.961,0,0,0,0,114.712c0,.144,0,.268,0,.4s0,.25,0,.316a27.844,27.844,0,0,0,6.452,17.546,26.151,26.151,0,0,0,5.454,5.148c10.9,7.655,13.186,19.415,1.293,28.735A27.955,27.955,0,0,0,.052,188.918C0,189.674,0,190.219,0,190.5c0,.036,0,.072,0,.11a27.9,27.9,0,0,0,9.806,21.266,26.094,26.094,0,0,0,2.1,1.65c11.223,7.881,13.312,20.111.205,29.552A27.951,27.951,0,0,0,.121,263.523,20.831,20.831,0,0,0,0,265.954c0,.056,0,.111,0,.167a27.968,27.968,0,0,0,27.968,27.968c.089,0,.177,0,.265,0,0,0,326.132,0,326.132-.012.251.007.5.012.755.012a27.969,27.969,0,0,0,15.246-51.417c-10.56-7.934-12.2-19.881.812-29.109a28.161,28.161,0,0,0,11.713-19.624,22.175,22.175,0,0,0,.2-3.125c0-.068,0-.135,0-.2a27.947,27.947,0,0,0-12.919-23.578c-10.385-7.934-11.92-19.79,1.008-28.962a27.723,27.723,0,0,0,9.148-10.837l.056-.12c.038-.08.076-.161.113-.241a27.778,27.778,0,0,0,2.378-8.286,22.273,22.273,0,0,0,.213-3.271c0-.072,0-.144,0-.216a27.952,27.952,0,0,0-13.538-23.962"
        transform="translate(1 -10.628)"
      />
    </clipPath>
  </defs>
</svg>
{/if}

<!-- sanduhr_quadratformat -->
{#if pattern && pattern.includes('sanduhr_quadratformat') || !pattern}
<svg
  xmlns="http://www.w3.org/2000/svg"
  width="0"
  height="0"
  viewBox="0 0 285.288 285.286"
>
  <defs>
    <clipPath
      id="sanduhr_quadratformat{id ? '_' +id: ''}"
      transform="{transformClip('sanduhr_quadratformat', cardWidth, cardHeight, smallSize)}"
    >
      <path
        d="M270.011,81.608c-9.85-7.949-11.072-19.546,1.632-28.558A27.628,27.628,0,0,0,283.28,30.2c0-.091,0-.18,0-.272a27.791,27.791,0,0,0-27.745-28.05c-.185,0-.369,0-.553.007h0l-.078,0-.118,0-.187.007c-.112,0-.223.011-.335.016h-148.9a16.05,16.05,0,0,0-1.606-.033c-.185,0-.369,0-.554.007h0l-.078,0-.118,0-.188.007c-.112,0-.223.011-.335.016H29.655a16.051,16.051,0,0,0-1.606-.033A28.049,28.049,0,0,0,0,29.926c0,.317.007.633.018.948a.1.1,0,0,0,0,.017c0,.295.024.77.085,1.383A27.884,27.884,0,0,0,3.168,42.886,27.133,27.133,0,0,0,11.945,53.3c10.531,7.394,13.042,18.606,2.56,27.774A28.043,28.043,0,0,0,0,105.252c0,.145,0,.269,0,.376v.021c0,.143,0,.251,0,.317a27.933,27.933,0,0,0,6.47,17.6,26.249,26.249,0,0,0,5.47,5.163c10.934,7.678,13.224,19.471,1.3,28.819A28.033,28.033,0,0,0,.052,179.675C0,180.433,0,180.981,0,181.262c0,.037,0,.073,0,.11A27.986,27.986,0,0,0,9.834,202.7a26.285,26.285,0,0,0,2.111,1.655c11.256,7.9,13.352,20.17.206,29.638A28.027,28.027,0,0,0,.122,254.5,20.909,20.909,0,0,0,0,256.936c0,.056,0,.111,0,.167a28.049,28.049,0,0,0,28.05,28.05c.09,0,.177,0,.266,0v0H254.781v-.013c.252.007.5.013.757.013a28.184,28.184,0,0,0,15.291-51.568c-10.591-7.957-12.233-19.938.814-29.194a26.749,26.749,0,0,0,8.422-9.966,27.875,27.875,0,0,0,3.02-9.715,22.161,22.161,0,0,0,.2-3.135c0-.068,0-.135,0-.2a27.76,27.76,0,0,0-12.652-23.647c-10.415-7.957-11.955-19.848,1.012-29.046a26.81,26.81,0,0,0,8.87-10.869l.056-.121c.038-.081.077-.161.113-.241a27.867,27.867,0,0,0,2.384-8.311,22.421,22.421,0,0,0,.214-3.28c0-.072,0-.144,0-.217a27.766,27.766,0,0,0-13.273-24.032"
        transform="translate(1 -0.868)"
      />
    </clipPath>
  </defs>
</svg>
{/if}

<!-- keks_hochformat -->
{#if pattern && pattern.includes('keks_hochformat') || !pattern}
<svg
  xmlns="http://www.w3.org/2000/svg"
  width="0"
  height="0"
  class="SvgClip"
  viewBox="0 0 295.85 392.168"
>
  <defs>
    <clipPath
      id="keks_hochformat{id ? '_' +id: ''}"
      transform="{transformClip('keks_hochformat', cardWidth, cardHeight, smallSize)}"
    >
      <path
        d="M1206.54,827.783a50.7,50.7,0,0,0-35.042-48.159,50.61,50.61,0,1,0-63.725-63.725,50.614,50.614,0,0,0-96.318,0,50.61,50.61,0,1,0-63.725,63.725,50.614,50.614,0,0,0,0,96.318,50.614,50.614,0,0,0,0,96.318,50.61,50.61,0,1,0,63.725,63.724,50.614,50.614,0,0,0,96.318,0A50.61,50.61,0,1,0,1171.5,972.26a50.614,50.614,0,0,0,0-96.318,50.7,50.7,0,0,0,35.042-48.159"
        transform="translate(-911.69 -679.858)"
      />
    </clipPath>
  </defs>
</svg>
{/if}

<!-- keks_querformat -->
{#if pattern && pattern.includes('keks_querformat') || !pattern}
<svg
  xmlns="http://www.w3.org/2000/svg"
  width="0"
  height="0"
  class="SvgClip"
  viewBox="0 0 392.168 295.85"
  preserveAspectRatio="xMidYMid meet"
>
  <defs>
    <clipPath
      id="keks_querformat{id ? '_' +id: ''}"
      transform="{transformClip('keks_querformat', cardWidth, cardHeight, smallSize)}"
    >
      <path
        d="M1057.616,293.849a50.7,50.7,0,0,0,48.159-35.042,50.61,50.61,0,1,0,63.725-63.725,50.614,50.614,0,0,0,0-96.318,50.61,50.61,0,1,0-63.725-63.725,50.614,50.614,0,0,0-96.318,0,50.614,50.614,0,0,0-96.318,0,50.61,50.61,0,1,0-63.724,63.725,50.614,50.614,0,0,0,0,96.318,50.61,50.61,0,1,0,63.724,63.725,50.614,50.614,0,0,0,96.318,0,50.7,50.7,0,0,0,48.159,35.042"
        transform="translate(-813.373 1.001)"
      />
    </clipPath>
  </defs>
</svg>
{/if}

<!-- keks_quadratformat -->
{#if pattern && pattern.includes('keks_quadratformat') || !pattern}
<svg
  xmlns="http://www.w3.org/2000/svg"
  width="0"
  height="0"
  class="SvgClip"
  viewBox="0 0 293.767 293.772"
>
  <defs>
    <clipPath
      id="keks_quadratformat{id ? '_' +id: ''}"
      transform="{transformClip('keks_quadratformat', cardWidth, cardHeight, smallSize)}"
    >
      <path
        d="M1112.576,145.883a50.338,50.338,0,0,0-34.793-47.818,50.251,50.251,0,1,0-63.273-63.273,50.255,50.255,0,0,0-95.635,0A50.251,50.251,0,1,0,855.6,98.065a50.255,50.255,0,0,0,0,95.635h-.017l.017.006a50.251,50.251,0,1,0,63.273,63.273,50.255,50.255,0,0,0,95.635,0,50.251,50.251,0,1,0,63.273-63.273l.016-.006h-.016a50.337,50.337,0,0,0,34.793-47.817"
        transform="translate(-819.809 1)"
      />
    </clipPath>
  </defs>
</svg>
{/if}

<!-- blume_hochformat -->
{#if pattern && pattern.includes('blume_hochformat') || !pattern}
<svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 287.195 386.472"
  class="SvgClip"
  width="0"
  height="0"
>
  <defs>
    <clipPath
      id="blume_hochformat{id ? '_' +id: ''}"
      transform="{transformClip('blume_hochformat', cardWidth, cardHeight, smallSize)}"
    >
      <path
        d="M1937.428,835.625c28.9-38.889,5.177-62.606-43.343-43.343,48.52-19.263,72.238-42.981,43.343-43.343,28.9-58.153,5.177-81.87-43.343-43.343-9.994-38.527-33.712-14.81-43.343,43.343,9.632-58.153-14.086-81.87-43.343-43.343-29.257-38.527-52.975-14.81-43.343,43.343-9.632-58.153-33.349-81.87-43.343-43.343-48.521-38.527-72.238-14.81-43.343,43.343-28.9.362-5.178,24.079,43.343,43.343-48.521-19.263-72.238,4.454-43.343,43.343-28.9,19.625-5.178,43.343,43.343,43.343-48.521,0-72.238,23.718-43.343,43.343-28.9,38.889-5.178,62.607,43.343,43.343-48.521,19.264-72.238,42.982-43.343,43.343-28.9,58.152-5.178,81.87,43.343,43.343,9.994,38.527,33.711,14.81,43.343-43.343-9.632,58.152,14.085,81.87,43.343,43.343,29.257,38.527,52.975,14.81,43.343-43.343,9.632,58.152,33.349,81.87,43.343,43.343,48.52,38.527,72.238,14.81,43.343-43.343,28.9-.362,5.177-24.079-43.343-43.343,48.52,19.264,72.238-4.454,43.343-43.343,28.9-19.625,5.177-43.343-43.343-43.343,48.52,0,72.238-23.717,43.343-43.343"
        transform="translate(-1663.801 -685.731)"
      />
    </clipPath>
  </defs>
</svg>
{/if}

<!-- blume_querformat -->
{#if pattern && pattern.includes('blume_querformat') || !pattern}
<svg
  xmlns="http://www.w3.org/2000/svg"
  width="0"
  height="0"
  class="SvgClip"
  viewBox="0 0 386.472 287.195"
>
  <defs>
    <clipPath
      id="blume_querformat{id ? '_' +id: ''}"
      transform="{transformClip('blume_querformat', cardWidth, cardHeight, smallSize)}"
    >
      <path
        d="M1892.468,281.146c38.888,28.9,62.606,5.177,43.342-43.343,19.264,48.52,42.981,72.238,43.343,43.343,58.153,28.9,81.87,5.177,43.343-43.343,38.527-9.994,14.81-33.712-43.343-43.343,58.153,9.632,81.87-14.086,43.343-43.342,38.527-29.258,14.81-52.975-43.343-43.343,58.153-9.632,81.87-33.349,43.343-43.343,38.527-48.521,14.81-72.238-43.343-43.343-.362-28.9-24.08-5.178-43.343,43.343,19.264-48.521-4.454-72.238-43.342-43.343-19.626-28.9-43.344-5.178-43.344,43.343,0-48.521-23.717-72.238-43.343-43.343-38.889-28.9-62.606-5.178-43.342,43.343-19.263-48.521-42.981-72.238-43.343-43.343-58.152-28.9-81.87-5.178-43.343,43.343-38.527,9.994-14.809,33.711,43.343,43.343-58.152-9.632-81.87,14.086-43.343,43.343-38.527,29.257-14.809,52.974,43.343,43.342-58.152,9.632-81.87,33.35-43.343,43.343-38.527,48.52-14.809,72.238,43.343,43.343.361,28.9,24.079,5.177,43.343-43.343-19.263,48.52,4.453,72.238,43.342,43.343,19.626,28.9,43.343,5.177,43.343-43.343,0,48.52,23.718,72.238,43.344,43.343"
        transform="translate(-1655.889 -7.52)"
      />
    </clipPath>
  </defs>
</svg>
{/if}

<!-- blume_quadratformat -->
{#if pattern && pattern.includes('blume_quadratformat') || !pattern}
<svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 307.544 309.965"
  class="SvgClip"
  width="0"
  height="0"
>
  <defs>
    <clipPath
      id="blume_quadratformat{id ? '_' +id: ''}"
      transform="{transformClip('blume_quadratformat', cardWidth, cardHeight, smallSize)}"
    >
      <path
        d="M1810.942,68.864c30.958-62.3,5.547-87.714-46.437-46.437C1753.8-18.85,1728.386,6.56,1718.067,68.864c10.319-62.3-15.091-87.714-46.436-46.437-31.346-41.277-56.756-15.867-46.437,46.437-10.319-62.3-35.73-87.714-46.437-46.437-51.984-41.277-77.395-15.867-46.437,46.437-30.958.388-5.547,25.8,46.437,46.437-49.637-19.707-75.028,2.577-50.271,40.9-24.757,38.323.634,60.607,50.271,40.9-51.984,20.639-77.395,46.049-46.437,46.437-30.958,62.3-5.547,87.714,46.437,46.437,10.707,41.277,36.118,15.867,46.437-46.437-10.319,62.3,15.091,87.714,46.436,46.437,31.346,41.277,56.757,15.867,46.437-46.437,10.32,62.3,35.73,87.714,46.437,46.437,51.985,41.277,77.395,15.867,46.437-46.437,30.958-.388,5.548-25.8-46.437-46.437,49.637,19.707,75.028-2.577,50.271-40.9,24.757-38.323-.634-60.607-50.271-40.9,51.984-20.639,77.395-46.049,46.437-46.437"
        transform="translate(-1517.859 -1.218)"
      />
    </clipPath>
  </defs>
</svg>
{/if}

<script>
  import transformClip from '../helpers/transformClip';

  export default {
    helpers: {
      transformClip,
    },
  };
</script>
